import React, { useState, useEffect, useContext } from "react";
import { withRouter } from 'react-router-dom';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Box from '@material-ui/core/Box';
import Toolbar from '@material-ui/core/Toolbar';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import Hidden from "@material-ui/core/Hidden";
import MenuIcon from '@material-ui/icons/Menu';
import Drawer from '@material-ui/core/Drawer';

import NBALogo from './nbaLogo/NBALogo';
import WNBALogo from "./wnbaLogo/WNBALogo";
import AppConstants from '../common/AppConstants';
import presentedBy from '../images/presentedby.png';
import RouteConstants from "../common/RouteConstants";
import AppBarMenu from "../sharedComponents/AppBarMenu";
import DialogBox from "../sharedComponents/DialogBox";
import AppDataContext from '../common/AppContext';
import TeamsMenu from './TeamsMenu';
import EditionsMenu from './EditionsMenu';
import TeamsAccordionMenu from './TeamsAccordionMenu';
import EditionsAccordionMenu from './EditionsAccordionMenu';


const useStyles = makeStyles(theme => ({

    AppBar: {
        background: '#000 !important',
        color: '#ffffff !important',
        zIndex: theme.zIndex.drawer + 1,
    },

    menu: {
        width: "250px",
    },

    itemIcon: {
        minWidth: "35px",
    },

    drawer: {
        width: 240,
        flexShrink: 0,
    },

    drawerPaper: {
        width: 240,
        background: "#1f1f1f"
    },

    title: {
        flexGrow: 1,
        '& h3': {
            fontSize: theme.palette.headerBarText.appNameSize,
            [theme.breakpoints.down('sm')]: {
                fontSize: theme.palette.headerBarText.mobileappNameSize,
            },
            [theme.breakpoints.only('md')]: {
                fontSize: theme.palette.headerBarText.mdappNameSize,
            },
        },
        '& h3, & h6': {
            fontFamily: theme.palette.headerText.fontFamily,
            color: '#ffffff',
            lineHeight: '1',
        },
        '& h6': {
            fontSize: theme.palette.headerBarText.subTitleSize,
            borderLeft: '1px solid #b5b5b5',
            marginLeft: theme.spacing(.75),
            paddingLeft: theme.spacing(.75),
            lineHeight: '1.2',
            [theme.breakpoints.down('sm')]: {
                fontSize: theme.palette.headerBarText.mobilesubTitleSize,
            },
            [theme.breakpoints.only('md')]: {
                fontSize: theme.palette.headerBarText.mdsubTitleSize,
            },
        },
        cursor: "pointer",
    },

    presentedBy: {
        color: '#ffffff',
        fontSize: '0.7rem',
        display: 'flex',
        alignItems: 'center',
        marginRight: theme.spacing(2.5),
        '& img': {
            marginLeft: theme.spacing(1),
        },
    },

    appVersion: {
        marginLeft: theme.spacing(2),
        fontSize: '10px'
    },

    formRoot: {
        display: "flex",
        flexWrap: "nowrap",
        color: "white",
        alignItems: 'center',
    },

    menuLabel: {
        color: "#b5b5b5",
        alignItems: 'center',
        fontSize: '0.75rem',
        marginLeft: theme.spacing(2.5),
        borderBottom: '3px solid transparent',
        [theme.breakpoints.down('sm')]: {
            justifyContent: 'flex-start',
            marginLeft: theme.spacing(1),
        },
    },

    highlightedMenu: {
        color: "#b5b5b5",
        alignItems: 'center',
        background: "transparent",
        fontSize: '0.75rem',
        marginLeft: theme.spacing(2.5),
        borderBottom: theme.palette.highlightedMenu.borderBottom,
        borderRadius: '0',
        [theme.breakpoints.down('sm')]: {
            justifyContent: 'flex-start',
            marginLeft: theme.spacing(1),
        },
    },


}));

const HeaderBar = (props) => {
    const classes = useStyles();
    const [drawer, showDrawer] = useState(false);
    const [selectedTab, setSelectedTabs] = useState("Home");
    const [showDialog, setOpenDialog] = useState(false);
    const { allTeams, allEditions, leagueId } = useContext(AppDataContext);
    let userData = {};
    if (localStorage.getItem("UserDetail") !== null && localStorage.getItem("UserDetail") !== undefined) {
        userData = JSON.parse(localStorage.getItem("UserDetail"));
    }
    const [fName, setUserFirstName] = useState((localStorage.getItem("UserDetail") !== null && localStorage.getItem("UserDetail") !== undefined) ? userData.firstName : "");
    const [lName, setUserLastName] = useState((localStorage.getItem("UserDetail") !== null && localStorage.getItem("UserDetail") !== undefined) ? userData.lastName : "");
    const [isUserLoggedin, setUserLoggedin] = useState((localStorage.getItem("UserDetail") !== null && localStorage.getItem("UserDetail") !== undefined) ? true : false);

    useEffect(() => {
        if (sessionStorage.getItem("selectedTab") !== null && sessionStorage.getItem("selectedTab") !== undefined)
            setSelectedTabs(sessionStorage.getItem("selectedTab"));
    }, []);

    useEffect(() => {
        setHighlightedMenu(props.activeTab);
    }, [props.activeTab]);

    const pushToRoute = (param) => {
        let byTeam = param === "team";
        let byEdition = param === "edition";
        let index = byTeam ? parseInt(sessionStorage.getItem("activeTileTeam")) : parseInt(sessionStorage.getItem("activeTileEdition"));
        if (byTeam) {
            let teams = [];
            let FavTeamId = "";
            if (localStorage.getItem("UserDetail") !== null && localStorage.getItem("UserDetail") !== undefined) {
                let userData = JSON.parse(localStorage.getItem("UserDetail"));
                FavTeamId = ((localStorage.getItem("UserDetail") !== null && localStorage.getItem("UserDetail") !== undefined && userData.favoriteTeams && userData.favoriteTeams.length > 0) ? userData.favoriteTeams[0] : "");
                teams = allTeams.filter(function (el, k) {
                    return parseInt(el.teamId) == parseInt(FavTeamId);
                });
                sessionStorage.removeItem("activeTileTeam");
            } else {
                if (index != undefined && index != null && !isNaN(index)) {
                    sessionStorage.setItem("activeTileTeam", index);
                } else {
                    index = 0;
                    sessionStorage.setItem("activeTileTeam", 0);
                }
                teams = allTeams.filter(function (el, k) {
                    return k == index;
                });
            }
            let teamSEOName = (teams !== undefined && teams.length > 0) ? teams[0].teamNameSEO : "";
            if (teamSEOName !== "" && teamSEOName !== null) {
                props.history.push({
                    pathname: RouteConstants.LOCKER_BY_TEAM + "/" + teamSEOName,
                    state: { team: byTeam, edition: byEdition, teamName: teamSEOName }
                });
            } else {
                props.history.push({
                    pathname: RouteConstants.LOCKER_BY_TEAM + "/atlanta-hawks",
                    state: { team: byTeam, edition: byEdition, teamName: "atlanta-hawks" }
                });
            }
        } else {
            let editions = [];

            if (index != undefined && index != null && !isNaN(index)) {
                sessionStorage.setItem("activeTileEdition", index);
            } else {
                index = 0;
                sessionStorage.setItem("activeTileEdition", 0);
            }
            editions = allEditions.filter(function (el, k) {
                return k == index;
            });
            let editionSEOName = (editions !== undefined && editions.length > 0) ? editions[0].editioN_NAME_SEO : "";

            if (editionSEOName !== "" && editionSEOName !== null) {
                props.history.push({
                    pathname: RouteConstants.LOCKER_BY_EDITION + "/" + editionSEOName,
                    state: { team: byTeam, edition: byEdition, editionName: editionSEOName }
                });
            } else {
                props.history.push({
                    pathname: RouteConstants.LOCKER_BY_EDITION + "/association-edition",
                    state: { team: byTeam, edition: byEdition, editionName: "association-edition" }
                });
            }
        }
    }

    const setHighlightedMenu = (param) => {
        if (param !== undefined && param === "schedule") {
            setSelectedTabs("Schedule");
            sessionStorage.setItem("selectedTab", "Schedule");
        } else if (param !== undefined && param === "team") {
            setSelectedTabs("Team");
            sessionStorage.setItem("selectedTab", "Team");
        } else if (param !== undefined && param === "edition") {
            setSelectedTabs("Edition");
            sessionStorage.setItem("selectedTab", "Edition");
            // }else if(param !== undefined && param === "trending"){
            //     setSelectedTabs("Trending");
            //     sessionStorage.setItem("selectedTab", "Trending");
        } else if (param !== undefined && param === "about") {
            setSelectedTabs("About");
            sessionStorage.setItem("selectedTab", "About");
        } else {
            setSelectedTabs("Home");
            sessionStorage.setItem("selectedTab", "Home");
        }
    }

    const pushToAboutusRoute = (param) => {
        props.history.push({
            pathname: RouteConstants.ABOUT_US
        });
    }

    const pushToScheuleRoute = (param) => {
        props.history.push({
            pathname: RouteConstants.SCHEDULE
            //state: { team: byTeam, edition: byEdition }
        });
    }

    const pushToHome = (param) => {
        props.history.push({
            pathname: RouteConstants.HOME
            //state: { team: byTeam, edition: byEdition }
        });
    }

    const loadSignInWidgetAsModal = async () => {
        await window.nbaUWID.loadWidget({
            modal: true,
            currentLanguage: "EN",
            hideLanguageToggle: true,
        });

        window.nbaUWID.showLogin();

        window.addEventListener("onLoginSuccess", function (response) {
            if (response) {
                setUserFirstName(response.detail.firstName);
                setUserLastName(response.detail.lastName);
                localStorage.setItem("UserDetail", JSON.stringify(response.detail));
                setUserLoggedin(true);
            }
        });

        window.addEventListener('onLoginFailure', (response) => {
            console.log("UW Login Failure: ", response)
            setUserLoggedin(false);
        });

        window.addEventListener('onSignUpSuccess', (response) => {
            setUserFirstName(response.detail.firstName);
            setUserLastName(response.detail.lastName);
            localStorage.setItem("UserDetail", JSON.stringify(response.detail));
            setUserLoggedin(true);
        });

        window.addEventListener('onSignUpFailure', (response) => {
            console.log("UW SignUp Failure:", response)
            setUserLoggedin(false);
        });
    };

    const openChangePasswordWidgetAsModal = (params) => {
        window.nbaUWID.showForgotPassword();

        window.addEventListener('onForgotPasswordSuccess', (response) => {
            console.log("UW Forgot Password Success::", response);
            setUserLoggedin(true);
        });

        window.addEventListener('onForgotPasswordFailure', (response) => {
            console.log("UW Forgot Password Failure::", response);
            setUserLoggedin(true);
        });

    }

    const signOut = () => {
        setUserFirstName("");
        setUserLastName("");
        localStorage.removeItem("UserDetail");
        setUserLoggedin(false);

        sessionStorage.setItem(AppConstants.START_DATE_FILTER, '');
        sessionStorage.setItem(AppConstants.END_DATE_FILTER, '');
        sessionStorage.setItem(AppConstants.GAME_TYPE_FILTER, AppConstants.ALL_GAMES);
        sessionStorage.setItem(AppConstants.TEAM_FILTER, AppConstants.ALL_TEAMS);
        props.history.push("/");
        window.location.reload();
    }

    return (
        <div>
            <AppBar position="fixed" className={classes.AppBar}>
                <Toolbar>
                    {leagueId === "00" ? <NBALogo onClick={pushToHome} /> : <WNBALogo onClick={pushToHome} />}
                    <Box component="div" display="flex" flexDirection="column" className={classes.title}>
                        <Box display="flex" flexDirection="row" alignItems="center">
                            <Typography variant="h3" component="h3" onClick={pushToHome}>
                                {AppConstants.APP_NAME}
                            </Typography>
                            <Typography variant="h6" component="h6" className={'headerSubTitle'} onClick={pushToHome}>
                                Every Locker, Every Player, Every Game.
                            </Typography>
                        </Box>
                        {/*{process.env.REACT_APP_SHOW_SPONSORS == true && <Typography variant="caption" component="div" className={classes.presentedBy}>*/}
                        {/*    Presented By <img src={presentedBy} alt="NBA LockerVision" title="NBA LockerVision" />*/}
                        {/*</Typography>}*/}
                    </Box>

                    <React.Fragment>
                        <Drawer anchor={'right'} open={drawer} className={classes.drawer}
                            classes={{
                                paper: classes.drawerPaper,
                            }}
                            onClose={() => {
                                showDrawer(false);
                            }}>

                            <Button color="inherit" className={(selectedTab === "Home") ? classes.highlightedMenu : classes.menuLabel} onClick={(e) => {
                                e.preventDefault();
                                showDrawer(false);
                                pushToHome();
                            }}>Home</Button>

                            <Button color="inherit" className={(selectedTab === "Schedule") ? classes.highlightedMenu : classes.menuLabel} onClick={(e) => {
                                e.preventDefault();
                                showDrawer(false);
                                pushToScheuleRoute();
                            }}>Schedule</Button>

                            <TeamsAccordionMenu selectedTab={selectedTab} hideDrawer={() => { showDrawer(false) }} />

                            <EditionsAccordionMenu selectedTab={selectedTab} hideDrawer={() => { showDrawer(false) }} />

                            <Button color="inherit" className={(selectedTab === "About") ? classes.highlightedMenu : classes.menuLabel} onClick={(e) => {
                                e.preventDefault();
                                showDrawer(false);
                                pushToAboutusRoute();
                            }}>About us</Button>

                            {/* <Button color="inherit" className={(selectedTab === "Trending") ? classes.highlightedMenu: classes.menuLabel} onClick={(e) => { 
                                e.preventDefault(); 
                                setHighlightedMenu("trending"); 
                            }}> Trending</Button> */}

                        </Drawer>
                    </React.Fragment>

                    <Hidden mdUp>
                        {!isUserLoggedin && <Box>
                            <Button color="inherit" className={classes.menuLabel} onClick={(e) => {
                                e.preventDefault();
                                //openSignInWidget();
                                loadSignInWidgetAsModal();
                            }}>Login</Button>
                        </Box>
                        }
                        {isUserLoggedin && <Box alignItems="center" display="flex" ml={1}>
                            <AppBarMenu
                                //openProfileWidget={(e) => {openProfileWidget()}} 
                                signOut={(e) => { signOut() }}
                                openChangePasswordWidget={(e) => {
                                    //openChangePasswordWidget()
                                    openChangePasswordWidgetAsModal();
                                }}
                                firstName={fName}
                                lastName={lName}
                            />
                        </Box>}
                        <MenuIcon onClick={() => {
                            showDrawer(true);
                        }} />
                    </Hidden>

                    <Hidden smDown>
                        <Box display="flex" height="38px" >
                            <Button color="inherit" className={(selectedTab === "Home") ? classes.highlightedMenu : classes.menuLabel} onClick={(e) => {
                                e.preventDefault();
                                pushToHome();
                                setHighlightedMenu("home");
                            }}>Home</Button>

                            { } <Button color="inherit" className={(selectedTab === "Schedule") ? classes.highlightedMenu : classes.menuLabel} onClick={(e) => {
                                e.preventDefault();
                                pushToScheuleRoute();
                                setHighlightedMenu("schedule");
                            }}>Schedule</Button>

                            <TeamsMenu
                                setHighlightedMenu={setHighlightedMenu}
                                selectedTab={selectedTab}
                                buttonColor="inherit" />

                            <EditionsMenu
                                setHighlightedMenu={setHighlightedMenu}
                                selectedTab={selectedTab}
                                buttonColor="inherit" />

                            <Button color="inherit" className={(selectedTab === "About") ? classes.highlightedMenu : classes.menuLabel} onClick={(e) => {
                                e.preventDefault();
                                pushToAboutusRoute();
                                setHighlightedMenu("about");
                            }}>About us</Button>

                            {/* <Button color="inherit" className={(selectedTab === "Trending") ? classes.highlightedMenu: classes.menuLabel} onClick={(e) => { 
                                e.preventDefault(); 
                                setHighlightedMenu("trending"); 
                            }}> Trending</Button> */}

                            {!isUserLoggedin &&
                                <Button color="inherit" className={classes.menuLabel} onClick={(e) => {
                                    e.preventDefault();
                                    //openSignInWidget();
                                    loadSignInWidgetAsModal();
                                }}>Login</Button>

                            }
                            {isUserLoggedin && <Box>
                                <AppBarMenu
                                    //openProfileWidget={(e) => {openProfileWidget()}} 
                                    signOut={(e) => { signOut() }}
                                    openChangePasswordWidget={(e) => {
                                        //openChangePasswordWidget()
                                        openChangePasswordWidgetAsModal();
                                    }}
                                    firstName={fName}
                                    lastName={lName}
                                />
                            </Box>}
                        </Box>
                    </Hidden>

                    {showDialog && <DialogBox></DialogBox>}

                </Toolbar>
            </AppBar>
        </div>
    )
}
export default withRouter(HeaderBar);